<script>

import { Overlay } from '../../'

export default {
    name: 'WMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Weighted Moving Average - Gives more weight to recent prices',
                preset: {
                    name: 'WMA $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#e91e63'
                    }
                }
            }
        },
        use_for() { return ['WMA'] },
        calc() {
            return {
                props: {
                    length: { def: 20, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    return wma(close, length)[0]
                `
            }
        }
    }
}
</script>
